import { useMessageSource } from 'src/i18n/useMessageSource'
import { S } from 'src/shared/styled/S'
import { COLORS } from 'src/theme/colors'
import { Box, Typography } from '@mui/material'
import { AddButton } from 'src/shared/button/Buttons'
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'

interface EvaluationCriteriaGridToolbarProps {
  numResults: number
  onAddCriteriaClick: React.MouseEventHandler<HTMLButtonElement>
}

export const EvaluationCriteriaGridToolbar = ({
  numResults,
  onAddCriteriaClick,
}: EvaluationCriteriaGridToolbarProps) => {
  const { getMessage } = useMessageSource()

  return (
    <S.DataGrid.ToolbarContainer sx={{ backgroundColor: COLORS.grey }} style={{ paddingInline: '0' }}>
      <Typography variant="subtitle1">
        {`${getMessage('label.configuration.grid.toolbar.results')}: ${numResults}`}
      </Typography>
      <Box>
        <AddButton
          messageKey="label.configuration.evaluation.criteria.grid.create.button"
          startIcon={<AddOutlinedIcon />}
          onClick={onAddCriteriaClick}
        />
      </Box>
    </S.DataGrid.ToolbarContainer>
  )
}
